
  import {
    defineComponent
  } from 'vue'

  export default defineComponent({
    name: 'MesCentresDinterets',
    components: {},
    setup() {
      /*   */
    }
  })
